var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnboardDepth(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 433,
    height: 932,
    viewBox: "0 0 433 932",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4268_15845)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4268_15845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M865 499C865 1008.21 573.09 1421 213 1421C-147.09 1421 -439 1008.21 -439 499C-439 -10.2066 -147.09 -423 213 -423C573.09 -423 865 -10.2065 865 499ZM335.001 598C335.001 522.889 277.693 462 207.001 462C136.309 462 79.0009 522.889 79.0009 598C79.0009 673.111 136.309 734 207.001 734C277.693 734 335.001 673.111 335.001 598Z",
    fill: "#0A150F",
    fillOpacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4268_15845",
    x: -508.005,
    y: -492.005,
    width: 1442.01,
    height: 1982.01,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34.5024,
    result: "effect1_foregroundBlur_4268_15845"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4268_15845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 433,
    height: 932,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardDepth);
export default __webpack_public_path__ + "static/media/onboardDepth.6b35ae9b8d20faa29ec447a488949afb.svg";
export { ForwardRef as ReactComponent };